<template>
    <span v-if="isSelected">
        <font-awesome-icon class="fa-fw" :icon="['fas', 'check']" />
    </span>
    <span v-else>
        <font-awesome-icon class="fa-fw" :icon="['fas', 'plus']" />
    </span>
</template>

<script>
    export default {
        name: "selected-icon",
        props: {
            isSelected: Boolean
        },
      created() {
          console.log(this.isSelected);
      }
    }
</script>

<style lang="scss" scoped>

</style>
